<template>
  <div>
    <Hero heading="My Work Experience" bg="bg_workflow.jpg" />
    <transition name="fade" appear>
      <div class="container">
        <div class="workflow-group">
          <h3>Vice President of Engineering | SYXiangQian Co., LTD.</h3>
          <h4>07/2018 – Present</h4>
          <div class="workflow-group__list">
            <ul>
              <li>Maintaining and developing an engaged, collaborative, creative, and multidisciplinary software team that focuses on quality and velocity.</li>
              <li>Championing best practices for the technical team on the development process, documentation, coding, error handling, testing, product quality, system performance, maintenance, and support.</li>
            </ul>
          </div>
        </div>

        <div class="workflow-group">
          <h3>Full-Stack Developer | PubPeer</h3>
          <h4>06/2018 – 04/2020</h4>
          <p>The overarching goal of the Foundation is to improve the quality of scientific research by enabling innovative approaches for community interaction.</p>
          <ul>
            <li>Developed new features for improving system functionality and user experience.</li>
            <li>Managed browser extension and its API development.</li>
            <li>Worked across teams to support customers, prioritize features, and deliver innovative solutions</li>
          </ul>
        </div>

        <div class="workflow-group">
          <h3>Browser Extension Developer | ExpressVPN</h3>
          <h4>02/2016 – 05/2018</h4>
          <p>ExpressVPN is a virtual private network service offered by the British Virgin Islands-registered company Express VPN International Ltd. The software is marketed as a privacy and security tool that encrypts users’ web traffic and masks their IP addresses.</p>
          <ul>
            <li>Developed VPN app for major browsers and QA automation tools</li>
          </ul>
        </div>

        <div class="workflow-group">
          <h3>Freelance Web Developer | Upwork (formerly oDesk)</h3>
          <h4>06/2012 – 08/2015</h4>
          <p>Upwork, formerly Elance-oDesk, is a global freelancing platform where businesses or individuals connect to conduct business.</p>
          <ul>
            <li>Modified open-source and proprietary software packages to correct errors and extend functionality</li>
          </ul>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Hero from '../Hero';

export default {
  name: 'Workflow',
  components: {
    Hero,
  },
};
</script>

<style scoped>
.intro {
  margin-bottom: 45px;
}

.workflow-group {
  &:not(:last-child) {
    margin-bottom: 30px;
    padding-bottom: 30px;
    border-bottom: 1px dashed #ccc;
  }

  svg {
    font-size: 80%;
  }

  ul {
    margin-bottom: 0;
  }
}

.workflow-group__list {
  @media (max-width: 644px) {
    > *:not(:last-child) {
      margin-bottom: 45px;
    }
  }

  @media (min-width: 645px) {
    display: flex;
  }

  ul {
    flex: 1;
    margin: 0;
  }
}
</style>
